// Default gallery slider
const imageGallerySlider = document.querySelectorAll('[data-slider="image-gallery__slider"]');

const imageGallerySliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  speed: 600,
  freeMode: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  breakpoints: {
    1024: {
      spaceBetween: 20,
      freeMode: false,
      slidesPerGroup: 2,
    },
  },
};

imageGallerySlider.forEach((el) => {
  const imageGalleryParent = el.closest('.image-gallery');
  const arrowRight = imageGalleryParent.querySelector('.arrow-right');
  const arrowLeft = imageGalleryParent.querySelector('.arrow-left');

  imageGallerySliderOptions.navigation.nextEl = arrowRight;
  imageGallerySliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, imageGallerySliderOptions);
});

// Infinite gallery slider

const infiniteGallery = document.querySelectorAll('.image-gallery');

infiniteGallery.forEach((slider) => {
  const track = slider.querySelector('.image-gallery__track');
  const row = slider.querySelector('.image-gallery__row');

  if (track && row) {
    track.appendChild(row.cloneNode(true));
    const rowWidth = row.offsetWidth;
    gsap.to(track, {
      x: `-${rowWidth}px`,
      duration: 60,
      ease: 'linear',
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % rowWidth),
      },
    });
  }
});
